import { render, staticRenderFns } from "./Baidu.vue?vue&type=template&id=0a51a8ec&scoped=true&"
import script from "./Baidu.vue?vue&type=script&lang=js&"
export * from "./Baidu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51a8ec",
  null
  
)

export default component.exports